import {priceFormat, SQUARE_METERS_UNIT} from "@pg-mono/string-utils";
import {Country, getPriceUnit, OfferType} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_ROOM_RANGES_CONTENT} from "../../constants/offer_generated_description_room_ranges_content";
import {IRoomRange} from "../../types/property/IRoomRange";
import {getOfferTypePluralize} from "../../utils/get_offer_type_string";

import * as styles from "./OfferGeneratedDescriptionRoomRanges.module.css";

interface IProps {
    country: Country;
    header: string;
    rooms_ranges: IRoomRange[];
    type: OfferType;
}

interface IRoomRangeItemContent {
    countLabel: string | null;
    roomAreaMax: string | null;
    roomAreaMin: string | null;
    roomPrice: string | null;
    rooms: number;
}

const {AREA_FROM_PREFIX, AREA_TO_PREFIX, getCountLabel, PRICE_FROM_PREFIX, ROOMS_AREA_LABEL} = OFFER_GENERATED_DESCRIPTION_ROOM_RANGES_CONTENT;

const getRoomRangeItemContent = (rooms: number, roomRange: IRoomRange, type: OfferType, priceUnit: string): IRoomRangeItemContent => {
    const isRoomAreaMinSameAsMax = roomRange.area.min === roomRange.area.max;

    const roomAreaMin = roomRange.area.min ? `${isRoomAreaMinSameAsMax ? "" : AREA_FROM_PREFIX}${roomRange.area.min}` : null;
    const roomAreaMax = roomRange.area.max && !isRoomAreaMinSameAsMax ? `${AREA_TO_PREFIX}${roomRange.area.max}` : null;
    const roomPrice = roomRange.price.min ? `${PRICE_FROM_PREFIX}${priceFormat(roomRange.price.min, {unit: priceUnit})}` : null;

    const offerTypeLabel = getOfferTypePluralize(roomRange.count, type);
    const countLabel = roomRange.count && offerTypeLabel ? getCountLabel(roomRange.count, offerTypeLabel) : null;

    return {
        countLabel,
        roomAreaMax,
        roomAreaMin,
        roomPrice,
        rooms
    };
};

export const OfferGeneratedDescriptionRoomRanges = (props: IProps) => {
    const {country, header, rooms_ranges, type} = props;

    const roomRanges = rooms_ranges.filter((roomRange) => roomRange.count > 0);

    if (!roomRanges.length) return null;

    const priceUnit = getPriceUnit(country);

    return (
        <>
            <p className={styles.header}>{header}</p>

            <ul>
                {roomRanges.map((roomRange) => {
                    const {countLabel, roomAreaMax, roomAreaMin, roomPrice} = getRoomRangeItemContent(roomRange.rooms, roomRange, type, priceUnit);

                    return (
                        <li key={roomRange.rooms}>
                            {roomRange.rooms}
                            {ROOMS_AREA_LABEL}
                            {roomAreaMin}
                            {roomAreaMax} {SQUARE_METERS_UNIT} {roomPrice}
                            {countLabel}
                        </li>
                    );
                })}
            </ul>
        </>
    );
};
import {priceFormat, SQUARE_METERS_UNIT} from "@pg-mono/string-utils";
import {Country, getPriceUnit, OfferType} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_ROOM_RANGES_CONTENT} from "../../constants/offer_generated_description_room_ranges_content";
import {IRoomRange} from "../../types/property/IRoomRange";
import {getOfferTypePluralize} from "../../utils/get_offer_type_string";

import * as styles from "./OfferGeneratedDescriptionRoomRanges.module.css";

interface IProps {
    country: Country;
    header: string;
    rooms_ranges: IRoomRange[];
    type: OfferType;
}

interface IRoomRangeItemContent {
    countLabel: string | null;
    roomAreaMax: string | null;
    roomAreaMin: string | null;
    roomPrice: string | null;
    rooms: number;
}

const {AREA_FROM_PREFIX, AREA_TO_PREFIX, getCountLabel, PRICE_FROM_PREFIX, ROOMS_AREA_LABEL} = OFFER_GENERATED_DESCRIPTION_ROOM_RANGES_CONTENT;

const getRoomRangeItemContent = (rooms: number, roomRange: IRoomRange, type: OfferType, priceUnit: string): IRoomRangeItemContent => {
    const isRoomAreaMinSameAsMax = roomRange.area.min === roomRange.area.max;

    const roomAreaMin = roomRange.area.min ? `${isRoomAreaMinSameAsMax ? "" : AREA_FROM_PREFIX}${roomRange.area.min}` : null;
    const roomAreaMax = roomRange.area.max && !isRoomAreaMinSameAsMax ? `${AREA_TO_PREFIX}${roomRange.area.max}` : null;
    const roomPrice = roomRange.price.min ? `${PRICE_FROM_PREFIX}${priceFormat(roomRange.price.min, {unit: priceUnit})}` : null;

    const offerTypeLabel = getOfferTypePluralize(roomRange.count, type);
    const countLabel = roomRange.count && offerTypeLabel ? getCountLabel(roomRange.count, offerTypeLabel) : null;

    return {
        countLabel,
        roomAreaMax,
        roomAreaMin,
        roomPrice,
        rooms
    };
};

export const OfferGeneratedDescriptionRoomRanges = (props: IProps) => {
    const {country, header, rooms_ranges, type} = props;

    const roomRanges = rooms_ranges.filter((roomRange) => roomRange.count > 0);

    if (!roomRanges.length) return null;

    const priceUnit = getPriceUnit(country);

    return (
        <>
            <p className={styles.header}>{header}</p>

            <ul>
                {roomRanges.map((roomRange) => {
                    const {countLabel, roomAreaMax, roomAreaMin, roomPrice} = getRoomRangeItemContent(roomRange.rooms, roomRange, type, priceUnit);

                    return (
                        <li key={roomRange.rooms}>
                            {roomRange.rooms}
                            {ROOMS_AREA_LABEL}
                            {roomAreaMin}
                            {roomAreaMax} {SQUARE_METERS_UNIT} {roomPrice}
                            {countLabel}
                        </li>
                    );
                })}
            </ul>
        </>
    );
};
